<template>
  <BaseModal ref="modal" modal-classes="max-w-md mx-auto" @modal-after-leave="$emit('closed')">
    <template #header>
      <span class="block text-xs text-gray-700 uppercase tracking-wider">υπηρεσια</span>
      <h3 class="text-2xl text-gray-900">Τροποποίηση {{ productService.name }}</h3>
    </template>

    <template #default="modalProps">
      <FormProductService
        :product-uuid="productService.productUuid"
        :product-service-uuid="productService.uuid"
        @success="modalProps.close"
        @cancel="modalProps.close"
      />
    </template>
  </BaseModal>
</template>

<script>
import FormProductService from './FormProductService.vue';

export default {
  name: 'ModalUpdate',
  components: {
    FormProductService,
  },
  props: {
    productService: {
      type: Object,
      required: true,
    },
  },
};
</script>
